import _has from 'lodash.has';
import _get from 'lodash.get';

export const has = (object: any, path: any) => {
  return _has(object, path);
};

export const get = (object: any, path: any, defaultValue?: any) => {
  return _get(object, path, defaultValue);
};
